import { render, staticRenderFns } from "./AddBookings.vue?vue&type=template&id=057cfd65&scoped=true"
import script from "./AddBookings.vue?vue&type=script&lang=js"
export * from "./AddBookings.vue?vue&type=script&lang=js"
import style0 from "./AddBookings.vue?vue&type=style&index=0&id=057cfd65&prod&scoped=true&lang=css"
import style1 from "./AddBookings.vue?vue&type=style&index=1&id=057cfd65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057cfd65",
  null
  
)

export default component.exports